import { Component } from 'preact';
import {
  getAspectRatio,
  onAspectRatioChange,
  clampedFitScale,
  getDesignHeight,
  DESIGN_WIDTH,
} from '../utils/uiScale';
import { isPhoneLayout } from '../utils/platform';
import { t } from '../localization/t';

function readViewport() {
  return { vw: window.innerWidth, vh: window.innerHeight };
}

export class AppStage extends Component {
  state = { aspect: getAspectRatio(), ...readViewport() };

  componentDidMount() {
    this.unsubAspect = onAspectRatioChange((aspect) => this.setState({ aspect }));
    this.onResize = () => this.setState(readViewport());
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    this.unsubAspect();
    window.removeEventListener('resize', this.onResize);
  }

  render() {
    const { aspect, vw, vh } = this.state;

    // Phone mode: no 16:9 letterbox, no scale floor. The canvas IS the
    // viewport; `.app-canvas--phone` boosts the cqw tokens so components
    // render at tappable physical sizes. Portrait shows a rotate gate
    // (pure CSS, `@media (orientation: portrait)`). The game is
    // landscape-only on phones.
    if (isPhoneLayout()) {
      if (typeof document !== 'undefined') {
        document.documentElement.style.setProperty('--canvas-scale', '1');
      }
      return (
        <div class="app-stage-root">
          <div class="app-canvas app-canvas--phone">
            {this.props.children}
            <div class="phone-rotate-overlay">
              <div class="phone-rotate-overlay-icon">⟳</div>
              <div class="phone-rotate-overlay-title">{t('Rotate your device')}</div>
              <div class="phone-rotate-overlay-sub">{t('Valkenhall plays in landscape')}</div>
            </div>
          </div>
        </div>
      );
    }

    const designHeight = getDesignHeight(aspect);
    const scale = clampedFitScale(vw, vh, DESIGN_WIDTH, designHeight);
    if (typeof document !== 'undefined') {
      document.documentElement.style.setProperty('--canvas-scale', String(scale));
    }
    const stageStyle = {
      width: `${DESIGN_WIDTH * scale}px`,
      height: `${designHeight * scale}px`,
    };
    return (
      <div class="app-stage-root">
        <div class="app-canvas" style={stageStyle}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default AppStage;
